export default "__VITE_ASSET__Bdlk5bSo__"